import { dictionary } from '@utils/dictionary';

interface IGetDisplayKeysParams {
  category: keyof typeof dictionary;
  data: Record<string, unknown>;
}

export const getDisplayKeys = ({ category, data }: IGetDisplayKeysParams) =>
  Object.keys(data).filter(key => key in dictionary[category]);
